import React from 'react';

import withBackboneMarket from 'Sportsbook/markets/backbone_adapter/with_backbone_market';
import withMarket from 'Sportsbook/markets/with_market';
import { TwoColumns } from 'Sportsbook/markets/views/two_columns/entry';
import Outcome from 'Sportsbook/outcomes/views/asian_handicap/entry';

const AsianHandicap = (props) => <TwoColumns {...props} outcomeComponent={Outcome} />;

export default withBackboneMarket(withMarket(AsianHandicap));
